import { Helmet } from 'react-helmet-async';
import { HtmlElementProps } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './page-wrapper.css';
import { NavBar } from './navbar';

export type PageWrapperProps = HtmlElementProps<HTMLDivElement> & {
  title?: string;
};

export const PageWrapper = (props: PageWrapperProps) => {
  const className = props.className ?? '';

  return (
    <>
      <Helmet>
        <title>{props.title}</title>
      </Helmet>

      <div className="pageWrapper">
        <NavBar />
        <div
          id="main-content"
          className={`pageContent ${className}`}
        >
          {props.children}
        </div>
      </div>
    </>
  );
};
